import React from "react";

export const TwitterIcon: React.FC = (props) => {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M512 49.248C492.96 57.6 472.672 63.136 451.52 65.824C473.28 52.832 489.888 32.416 497.696 7.808C477.408 19.904 455.008 28.448 431.136 33.216C411.872 12.704 384.416 0 354.464 0C296.352 0 249.568 47.168 249.568 104.992C249.568 113.312 250.272 121.312 252 128.928C164.736 124.672 87.52 82.848 35.648 19.136C26.592 34.848 21.28 52.832 21.28 72.192C21.28 108.544 40 140.768 67.904 159.424C51.04 159.104 34.496 154.208 20.48 146.496C20.48 146.816 20.48 147.232 20.48 147.648C20.48 198.656 56.864 241.024 104.576 250.784C96.032 253.12 86.72 254.24 77.056 254.24C70.336 254.24 63.552 253.856 57.184 252.448C70.784 294.016 109.376 324.576 155.264 325.568C119.552 353.504 74.208 370.336 25.12 370.336C16.512 370.336 8.256 369.952 0 368.896C46.496 398.88 101.6 416 161.024 416C354.176 416 459.776 256 459.776 117.312C459.776 112.672 459.616 108.192 459.392 103.744C480.224 88.96 497.728 70.496 512 49.248Z"
        fill="white"
      />
    </svg>
  );
};

export const TwitterIconTop: React.FC = (props) => {
  return (
    <svg
      width="35"
      height="28"
      viewBox="0 0 400 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M512 49.248C492.96 57.6 472.672 63.136 451.52 65.824C473.28 52.832 489.888 32.416 497.696 7.808C477.408 19.904 455.008 28.448 431.136 33.216C411.872 12.704 384.416 0 354.464 0C296.352 0 249.568 47.168 249.568 104.992C249.568 113.312 250.272 121.312 252 128.928C164.736 124.672 87.52 82.848 35.648 19.136C26.592 34.848 21.28 52.832 21.28 72.192C21.28 108.544 40 140.768 67.904 159.424C51.04 159.104 34.496 154.208 20.48 146.496C20.48 146.816 20.48 147.232 20.48 147.648C20.48 198.656 56.864 241.024 104.576 250.784C96.032 253.12 86.72 254.24 77.056 254.24C70.336 254.24 63.552 253.856 57.184 252.448C70.784 294.016 109.376 324.576 155.264 325.568C119.552 353.504 74.208 370.336 25.12 370.336C16.512 370.336 8.256 369.952 0 368.896C46.496 398.88 101.6 416 161.024 416C354.176 416 459.776 256 459.776 117.312C459.776 112.672 459.616 108.192 459.392 103.744C480.224 88.96 497.728 70.496 512 49.248Z"
        fill="white"
      />
    </svg>
  );
};
